export {
  EU_COMPANY_AGREEMENTS,
  TOS,
  UK_COMPANY_AGREEMENTS,
} from '@treyd-io/shared/constants/consents';

export const AIRWALLEX_GLOBAL_TOS =
  'https://www.airwallex.com/terms/acceptable-use-policy';

export const AIRWALLEX_TOS_EU =
  'https://www.airwallex.com/eu/nl/terms#acceptable-use-policy';

export const AIRWALLEX_TOS_UK =
  'https://www.airwallex.com/uk/terms/acceptable-use-policy';

export const AIRWALLEX_CONNECTED_ACCOUNT_TERMS = `https://www.airwallex.com/terms/treyd-connected-account-terms`;

//TODO: Move to shared after enabling receivables consents to ops.
export const LATEST_COMPANY_AGREEMENT_VERSION = 5;
export const LATEST_TOS_VERSION = 4;
